import React from 'react';
import Brand from '../component/Brand';
import Brand2 from '../component/Brand2';
import Newest from '../component/Newest';

const Home2 = () => {
    return (
        <div>
            <Brand2/>
            <Newest></Newest>
            <Brand/>
        </div>
    );
};

export default Home2;